import { Component } from '@angular/core';
import { ParticipantHeaderComponent as LsrParticipantHeaderComponent } from '../../../LSR/_layout/participant-header/participant-header.component';
import { ParticipantFooterComponent as LsrParticipantFooterComponent } from '../../../LSR/_layout/participant-footer/participant-footer.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-lsr-participant-layout',
  templateUrl: './participant-layout.component.html',
  styleUrls: ['./participant-layout.component.css'],
  standalone: true,
  imports: [RouterModule,LsrParticipantHeaderComponent,LsrParticipantFooterComponent]
})
export class ParticipantLayoutComponent {
  constructor() {
    console.log('LSR ParticipantLayoutComponent constructor called');
  }

  ngOnInit() {
    console.log('LSR ParticipantLayoutComponent ngOnInit called');
  }
}
